import React from 'react'
import Layout from '../../../components/Layout'
import { Link } from "gatsby"

export default function Tekmovanje() {

    return (
        <Layout>
            <main className="container px-6 font-medium text-lg text-primary">
                <h1 className="text-5xl mt-16 mb-8 lg:text-6xl lg:my-16 xl:text-7xl xl:my-20 mb-5">ZOT 2021 - Navodila<span className="text-xs bg-primary px-2 py-1 text-white ml-2">online</span></h1>
                <nav className="mb-10 lg:-mt-10 xl:mb-20 lg:text-2xl lg:flex items-center">
                    <p>Pojdi na: </p>
                    <ul className="lg:flex">
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#casovnica">Časovnica</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#prijava">Prijava</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#naloge">Reševanje in oddajanje nalog</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#pomoc">Pomoč in komunikacija</a><span className="hidden lg:inline-block">, </span></li>
                    </ul>
                </nav>
                <section className=" lg:text-xl text-lg text-container">
                    <p className="pb-6">
                        Dodatne infromacije in navodila za prijavljene ekipe na prvem (in zadnjem?) ZOT-a na spletu. Povezava do nalog bo objavljena ob začetku tekmovanja.
                    </p>

                </section>
                <section className="mt-5 text-container">
                    <h2 id="casovnica" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Časovnica</h2>
                    <p className="pb-6">
                        <span className="border-b-2 border-primary">GG kategorija</span>
                    </p>
                    <div className="flex mb-4">
                        <div className="mr-5">8:00</div>
                        <p>
                            Odprte prijave na tekmovanje.Prosim, da se na tekmovanje prijavite najkasneje do <span className=" border-primary border-b-2">8:45</span>!
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">8.50</div>
                        <p>
                            Pozdrav ekip na Discordu (zvočni kanal General).
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">9.00</div>
                        <p>
                            Začetek tekmovanja <br />
                        Dostop do seznama nalog za GG kategorijo.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">9.00</div>
                        <p>
                            Konec tekmovanja  <br />
                        Na Discord kanal <span className="font-mono">#splošno</span> bo objavljen obrazec za pritožbe in pripombe.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">19.30</div>
                        <p>
                            Večerni program
                        </p>
                    </div>


                    <br />


                    <p className="pb-6">
                        <span className="border-b-2 border-primary">PP+ kategorija</span>
                    </p>
                    <div className="flex mb-4">
                        <div className="mr-5">14:00</div>
                        <p>
                            Odprte prijave na tekmovanje.Prosim, da se na tekmovanje prijavite najkasneje do <span className=" border-primary border-b-2">14:45</span>!
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">14.50</div>
                        <p>
                            Pozdrav ekip na Discordu (zvočni kanal General).
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">15.00</div>
                        <p>
                            Začetek tekmovanja <br />
                        Dostop do seznama nalog za PP kategorijo.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">18.00</div>
                        <p>
                            Konec tekmovanja  <br />
                        Na Discord kanal <span className="font-mono">#splošno</span> bo objavljen obrazec za pritožbe in pripombe.
                        </p>
                    </div>
                    <div className="flex mb-4">
                        <div className="mr-5">19.30</div>
                        <p>
                            Večerni program
                        </p>
                    </div>

                </section>
<br/>
                <section className="mt-5 text-container">
                    <h2 id="prijava" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Prijava</h2>
                    <p className="pb-6">
                        <span className="border-b-2 border-primary">PRIJAVA NA TEKMOVANJE</span>
                    </p>
                    <ol className="list-disc ml-5 pb-6">
                        <li><span className="border-b-2 border-primary">Pred začetkom tekmovanja se mora ekipa prijaviti.</span></li>
                        <li>Prijavo ekipa opravi z izpolnitvijo obrazca ‘Oznaka ekipe’, v katerega odda fotografijo celotne ekipe.</li>
                        <li>Oznaka ekipe je napis ali zastava s številko in imenom ekipe.</li>
                    </ol>
                    <Link className="py-3 block text-center text-3xl text-white bg-primary" to="https://forms.gle/YWwYAvUM56xSWfYy5">Prijva ekipe v kategoriji GG</Link>
                    <br/>
                    <Link className="py-3 block text-center text-3xl text-white bg-primary" to="https://forms.gle/hmHKypTzxh8eqSVN6">Prijava ekipe v kategoriji PP+</Link>
                    <br/>
                    <p className="pb-6">
                        <span className="border-b-2 border-primary">PRIJAVA NA DISCORD SERVER</span>
                        <br />
                        Za pomoč ekipam in komunikacijo med tekmovalci smo ustvarili ZOT 2021 Discord server, do katerega lahko dostopate preko te povezave: <a className="border-b-2 border-primary" href="https://discord.gg/dkvuuv2zp8">https://discord.gg/dkvuuv2zp8</a>.
                       <br/> Prijava na na Discord server je obvezna pred začetkom tekmovanja!

                    </p>
                    <ol className="list-disc ml-5 pb-6">
                        <li>Prijavi naj se samo en član ekipe. Lahko uporabite že obstoječi račun.</li>
                        <li>Pojavno ime računa (nickname) spremenite v številko in ime ekipe (npr. 103 Črni Panterji), da vas bomo lažje prepoznali.</li>
                        <li>Predstavite ekipo na kanalu #prijava. Komaj po predstavitvi vam bo administrator serverja dodelil dostop do ostalih komunikacijskih kanalov.
</li>
                        <li>Uspešno ste se prijavili! Za obrazložitev uporabe kanalov glej poglavje Pomoč in komunikacija.</li>
                    </ol>
                </section>

                <section className="mt-5 text-container">
                    <h2 id="naloge" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Reševanje in oddaja nalog</h2>
                        <Link className="py-2 my-3 block text-center text-xl text-white bg-primary" to="/naloge/sliva/">PP naloge</Link>
                    <p className="pb-6">
                        Naloge rešujete preko obrazcev v seznamu nalog, ki je objavljen po začetku tekmovanja na spletni strani ZOT 2021. Povezavo do seznama nalog boste dobili tudi po e-pošti pred začetkom tekmovanja.
                    </p>
                    <p className="pb-6">
                        Do obrazcev za reševanje nalog lahko dostopate samo preko seznama nalog na spletni strani ZOT 2021. Na tej strani je tudi dokument z nalogami, njihovim opisi ter točkami, ki si lahko tudi natisnete.

                    </p>
                    <p className="pb-6">
                        Obrazec odprite s klikom na gumb ‘Oddaja’ pod želeno nalogo na seznamu.

                    </p>
                    <p className="pb-6">
                        Vrstni red reševanja nalog je lahko poljuben.

                    </p>
                    <p className="pb-1">
                        Tipi nalog so:

                    </p>
                    <ol className="list-decimal ml-5 pb-6">
                        <li>

                    <p className="pb-1">
                    <span className="border-b-2 border-primary">ODDAJA BESEDILNIH NALOG IN KVIZOV</span>

                    </p>
                    <ul className="list-disc ml-5 pb-6">
                        <li>Besedilne naloge in kvize rešujete preko obrazcev v seznamu nalog.</li>
                    </ul>
                    </li><li>
                    <p className="pb-1">
                    <span className="border-b-2 border-primary">ODDAJA FOTOGRAFIJ</span>

                    </p>
                    <ul className="list-disc ml-5 pb-3">
                        <li>Fotografije naložite s pomočjo temu namenjenega okvirčka v obrazcu naloge.</li>
                        <li>Fotografije naj ne bodo večje od 100 MB.</li>
                        <li>V vsako fotografijo zajemite tudi <span className="border-b-2 border-primary">oznako vaše ekipe</span>!</li>
                    </ul>
                    <p className="pb-1">
                    Ustvarjanje kolaža

                    </p>
                    <ul className="list-disc ml-5 pb-6">
                        <li>Če naloga zahteva oddajo večih fotografij, jih s pomočjo urejevalnika fotografij sestavite v kolaž in oddajte kot eno datoteko.
</li> <li>
Predlagamo aplikaciji Layout (Instagram) ali MOLDIV (JellyBus Inc.).
</li>
                    </ul>
                    </li><li>
                    <p className="pb-1">
                    <span className="border-b-2 border-primary">ODDAJA VIDEO POSNETKOV</span>

                    </p>
                    <ul className="list-disc ml-5 pb-6">
                        <li>Video posnetke naložite s pomočjo temu namenjenega okvirčka v obrazcu naloge.</li>
                        <li>Poskrbite, da bo rezultat, ki ga od vas zahteva naloga, na video posnetku jasno prikazan.</li>
                        <li>Posnetki naj ne bodo daljši od 60 sekund.</li>
                        <li>Na začetku posnetka prikažite <span className="border-b-2 border-primary">oznako vaše ekipe</span>!</li>
                    </ul>
                    </li>
                    </ol>
                </section>

                <section className="mt-5 text-container">
                    <h2 id="pomoc" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Pomoč in komunikacija</h2>
                    <p className="pb-6">
                    Za komunikacijo med ekipami smo ustvarili Discord server. Tam lahko spremljate potek tekmovanja, delite meme o tekmovanju ali prosite za tehnično ter vsebinsko pomoč.</p>
                    <p>Kanali za ekipe:</p>
                    <ul className="list-disc ml-5 pb-6">
                        <li><span className="border-b-2 border-primary">Splošni kanal</span> za obveščanje o poteku tekmovanja, druženje med ekipami in deljenje vtisov.</li>
                        <li><span className="border-b-2 border-primary">Kanal šal</span> za deljenje memov o ZOT-u in taborništvu. Bodite spoštljivi!</li>
                        <li><span className="border-b-2 border-primary">Kanal za vsebinsko pomoč</span> je namenjen vprašanjem o vsebini in zahtevah nalog na tekmovanju.</li>
                        <li><span className="border-b-2 border-primary">Kanal za pomoč z informacijsko tehnologijo</span> (IT) je namenjen reševanju morebitnih težav, ki se navezujejo na delovanje Discord serverja, spletne strani in obrazcev za oddajo nalog. Pišite nam, če vam kaj ne dela!</li>
                    </ul>

                    
                    <p>Če nas ne morete doseči preko Discord serverja, nam pišite na <a href="mailto:zot.prijave@gmail.com"><span className="border-b-2 border-primary">zot.prijave@gmail.com</span></a></p>
                </section>
            </main>
        </Layout>
    );
}